import { useContext } from "react";
import { createContext, useState, useEffect } from "react";
import REACT_APP_API_URL from "../utils/constant";

export const PlansContext = createContext();

export const PlansProvider = ({ children }) => {
  const [plans, setPlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchUserPlans = async (userId) => {
    try {
      setLoading(true);
      const response = await fetch(
        `${REACT_APP_API_URL}get-planes?id=${userId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("user")}`,
          },
        }
      );
      const result = await response.json();
      console.log("plans", result);

      if (result?.data) {
        setPlans(result.data);
      }
    } catch (error) {
      console.error("Error fetching user plans:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <PlansContext.Provider
      value={{ plans, selectedPlan, setSelectedPlan, fetchUserPlans, loading }}
    >
      {children}
    </PlansContext.Provider>
  );
};

export const usePlanContext = () => {
  return useContext(PlansContext);
};
